export class PartyRole
{
    partyId? : number;
    name : string;
    roleId? : number;
}


// WEBPACK FOOTER //
// ./src/app/modules/validate-loss-data-submission/shared/entities/party-role.ts